<div class="position-relative w-100 h-100">
  @if (purpose !== 'assignment') {
    <ix-pane
      heading="{{ 'battery_pass.edit.attribute_assignments_pane.headline' | translate }}"
      composition="right"
      [size]="'33%'"
      variant="floating"
      [hideOnCollapse]="true"
      [expanded]="assignmentPaneExpanded"
      (expandedChanged)="onAssignmentPaneChanged($event)"
      class="position-fixed end-0 detail-pane"
      >
      <app-assignment-details [assignmentPaneData]="assignmentPaneData"
        [batteryPassId]="passportId"
        (removedAssignment)="updateAssignmentLabelsOnRemove($event)"
      ></app-assignment-details>
    </ix-pane>
  }

  <ix-layout-grid [columns]="12" class="content flex-wrap flex-row">
    <ix-row>
      <ix-col>
        <ix-content-header
          [hasBackButton]="true"
          (backButtonClick)="onCancelClick()"
          id="batteryPassWorkflowHeader"
          headerSubtitle="{{'battery_pass.edit.sub_header' | translate: {product: schemaName} }}"
          [headerTitle]="
            ((purpose === 'edit' || purpose === 'assignment')
              ? 'battery_pass.edit.header'
              : 'battery_pass.create.header'
            ) | translate: {id: passDisplayName}
          "
          >
          <div
            class="d-flex align-items-center gap-3 h-100 label-row">
            @if (masterChildFlag) {
              <ix-pill
                [variant]="isMasterPassport ? 'info' : 'neutral'"
                icon="info">
                {{ `battery_pass.list.${(isMasterPassport ? 'master' : 'child')}` | translate }}
              </ix-pill>
            }
            <!--
            The status pill is hidden when purpose is 'assignment' because
            passport status is not relevant or should not be shown in assignment context.
            -->
            @if (passportStatus && purpose !== 'assignment') {
              <ix-pill
                [variant]="passportStatus === StatusStringEnum.DRAFT ? 'critical' : 'success'"
                class="me-3"
                id="editBatteryItemStatus">
                {{ 'battery_pass.list.' + (passportStatus || 'draft') | translate }}
              </ix-pill>
            }
            <ng-container>
              <ix-icon-button icon="more-menu"
              id="assetDropdownTrigger" variant="subtle-primary"></ix-icon-button>
              <ix-dropdown class="dropdown-background"
                trigger="assetDropdownTrigger">
                <ix-dropdown-item #submenu
                  [class.d-none]="purpose !== 'assignment'"
                  [disabled]="!canSwitchProvisionType"
                                  [label]="(
                      isCatenaXEnabled
                        ? 'battery_pass.edit.provision_type.cx'
                        : 'battery_pass.edit.provision_type.portal'
                      ) | translate"
                  icon="cloud-new">
                </ix-dropdown-item>
                @if (purpose === 'assignment') {
                  <ix-dropdown-item (click)="onProvideAssetClick()"
                    [disabled]="!isCatenaXEnabled || !edcConfigured"
                    [label]="'battery_pass.attribute_selection.provide_asset_button_text'| translate"
                    icon="connected"
                    id="provideCXAssetDropdownItem"
                    onkeypress="">
                  </ix-dropdown-item>
                }
                @if (purpose !== 'assignment') {
                  <ix-dropdown-item (click)="onChangePassportNameClick()"
                    [label]="'battery_pass.edit.change_passport_name'| translate"
                    icon="rename"
                    id="changePassNameDropdownItem"
                    onkeypress="">
                  </ix-dropdown-item>
                }
                @if (purpose !== 'assignment' && isHierarchyFeatureEnabled) {
                  <ix-dropdown-item (click)="onChangeHierarchyClick()"
                    *ngxPermissionsOnly="['DATA_MANAGER']"
                    [label]="'battery_pass.hierarchy.headline'| translate"
                    icon="hierarchy"
                    id="changeHierarchyDropdownItem"
                    onkeypress="">
                  </ix-dropdown-item>
                }
                @if (purpose === 'edit') {
                  <ix-dropdown-item (click)="onRemoveClick()"
                    [label]="'battery_pass.private.remove' | translate"
                    icon="trashcan"
                    id="editBatteryPassRemoveDropdownItem"
                    onkeypress="">
                  </ix-dropdown-item>
                }
              </ix-dropdown>
              @if (canSwitchProvisionType) {
                <ix-dropdown
                  [ixDropdownTrigger]="submenu"
                  class="dropdown-background"
                  placement="right-start">
                  <ix-dropdown-item (click)="onProvisionTypeCXClick()"
                    [checked]="isCatenaXEnabled"
                    [label]="'battery_pass.provision.provision_catenax' | translate"
                  onkeypress=""></ix-dropdown-item>
                  <ix-dropdown-item (click)="onProvisionTypeAPIClick()"
                    [checked]="!isCatenaXEnabled"
                    [label]="'battery_pass.provision.provision_portal' | translate"
                  onkeypress=""></ix-dropdown-item>
                </ix-dropdown>
              }
            </ng-container>
          </div>
        </ix-content-header>
      </ix-col>
    </ix-row>
    @if (!errorLoadingPassData) {
      <ix-row>
        <ix-col class="workflow-container overflow-x sticky">
          @if (schema) {
            <app-category-workflow (categorySelected)="selectedCategory = $event"
              [passportId]="passportId"
              [purpose]="purpose"
              [schemaId]="schema.id">
            </app-category-workflow>
          }
        </ix-col>
        @if (loading) {
          <ix-col class="d-flex justify-content-center">
            <ix-spinner size="large"></ix-spinner>
          </ix-col>
        }
        @if (!loading) {
          <ix-col class="content-wrapper input-content">
            <ix-row class="assignment-bar ps-0 pb-0 pt-2">
              @if (purpose !== 'assignment') {
                <ix-col
                  class="align-content-center p-0" size="8">
                  <div *ngxPermissionsOnly="allButDataProvider"
                    class="d-flex align-items-center justify-content-between">
                    <ix-pill
                      [variant]="'info'"
                      id="batteryPassWorkflowSelectedPill"
                      [outline]="true"
                      >
                      <ix-typography class="d-inline me-1">{{
                        'battery_pass.edit.selected' | translate
                        }}
                      </ix-typography>
                      <ix-typography [bold]="true" class="d-inline">{{
                        attributeSelections?.length
                        }}
                      </ix-typography>
                    </ix-pill>
                    @if (isCatenaXEnabled) {
                      <div class="w-100 text-end"
                        id="batteryPassCxImportPill_wrapper">
                        @if (purpose === 'edit') {
                          <ix-button
                            (click)="onImportCXClick()"
                  [disabled]="
                    isLoadingUserData || getAssignmentProviders().length === 0
                  "
                            icon="import"
                            id="batteryPassCxImportPill"
                            onkeypress=""
                            variant="secondary"
                            >
                            {{ 'battery_pass.import.button' | translate }}
                          </ix-button>
                        }
                      </div>
                    }
                    @if (isCatenaXEnabled && getAssignmentProviders().length === 0) {
                      <ix-tooltip
                        id="batteryPassCxImportPill_tooltip"
                        placement="right"
                        for="#batteryPassCxImportPill_wrapper"
                        >
                        {{ 'battery_pass.import.no_open_assignments' | translate }}
                      </ix-tooltip>
                    }
                  </div>
                </ix-col>
              }
              @if (purpose !== 'assignment') {
                <ix-col
                  class="align-content-center p-0 ps-3" size="4">
                  @if (!isLoadingUserData && attributeSelections?.length) {
                    <ix-select
                      id="batteryPassWorkflowSelectAssignee"
                      [i18nPlaceholder]="'battery_pass.edit.assign_data_provider' | translate"
                      [hideListHeader]="true"
                      class="select-assignee-dropdown">
                      @for (user of dataProviders; track user) {
                        <ix-select-item
                          label="{{ user.email }}"
                          id="{{ 'batteryPassWorkflowSelectedItem.' + user.id }}"
                          value="{{ user.id }}"
                          (itemClick)="onDataProviderSelected(user)"
                        ></ix-select-item>
                      }
                    </ix-select>
                  }
                  @if (!isLoadingUserData && !attributeSelections?.length) {
                    <ix-select
                      [disabled]="true"
                      [value]="'assign_data_provider'"
                      id="batteryPassWorkflowSelectAssigneeEmpty"
                      class="select-assignee-dropdown">
                      <ix-select-item
                        label="{{ 'battery_pass.edit.assign_data_provider' | translate }}"
                        value="assign_data_provider">
                      </ix-select-item>
                    </ix-select>
                  }
                  @if (isLoadingUserData) {
                    <ix-spinner size="small"></ix-spinner>
                  }
                </ix-col>
              }
            </ix-row>
            @if (schema) {
              <app-form-builder (cancelClicked)="onCancelClick()"
                [selectedCategory]="selectedCategory"
                [attributeAssignments]="initialAttributeLabelData.concat(appendableLabelData)"
                [isUserListLoading]="isLoadingUserData"
                [fieldSaveFunction]="purpose === 'assignment' ? saveFunction.bind(this) : undefined"
                [isCatenaX]="isCatenaXEnabled"
                [passportId]="passportId"
                [schemaId]="schema.id"
                [purpose]="purpose"
                (expandAssignmentPane)="expandAssignmentPane($event)"
                (saveClicked)="onSaveClick($event)"
              ></app-form-builder>
            }
          </ix-col>
        }
      </ix-row>
    }
    @if (errorLoadingPassData) {
      <ix-row class="justify-content-center">
        <div class="error-wrapper h-100 text-center">
          <p class="xxl-text d-inline">{{ errorDetail.errorCode | translate }}</p>
          <ix-typography class="mb-2" format="display-xl">{{
            errorDetail.errorHeader | translate
            }}
          </ix-typography>
          <ix-typography class="mb-4" format="body">{{
            errorDetail.errorDescription | translate: {id: passportId}
            }}
          </ix-typography>
        </div>
      </ix-row>
    }
  </ix-layout-grid>
</div>

<ng-template #cancelModal let-modal>
  <div>
    <ix-modal-header id="batteryPassWorkflowCancelModalHeader">
      {{
      ((purpose === 'edit' || purpose === 'assignment')
      ? 'battery_pass.edit.cancel.modal_headline'
      : 'battery_pass.create.cancel.modal_headline'
      ) | translate
      }}
    </ix-modal-header>
    <ix-modal-content id="batteryPassWorkflowCancelModalContent">
      {{
      ((purpose === 'edit' || purpose === 'assignment')
      ? 'battery_pass.edit.cancel.modal_content'
      : 'battery_pass.create.cancel.modal_content'
      ) | translate: {id: modal.data}
      }}
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button
        (click)="modal.dismiss()"
        class="close-modal"
        id="batteryPassWorkflowCancelModalNoButton"
        onkeypress=""
        variant="secondary"
        >
        {{ 'general.cancel' | translate }}
      </ix-button>
      <ix-button
        id="batteryPassWorkflowCancelModalYesButton"
        class="dismiss-modal"
        (click)="modal.close(true)"
        onkeypress=""
        variant="danger-primary"
        >
        {{ 'battery_pass.edit.cancel.discard_button' | translate }}
      </ix-button>
    </ix-modal-footer>
  </div>
</ng-template>

<ng-template #changeNameModal let-modal>
  <div>
    <ix-modal-header id="batteryPassChangePassportNameModalHeader">
      {{ 'battery_pass.edit.change_passport_name' | translate }}
    </ix-modal-header>
    <ix-modal-content id="batteryPassChangePassportNameModalContent">
      <ix-input #passportNameInput [value]="passDisplayName ?? ''"
        maxLength="50"
        [label]="'battery_pass.edit.new_passport_name' | translate"
      class="w-100"></ix-input>
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button
        (click)="modal.dismiss()"
        class="close-modal"
        id="batteryPassChangePassportNameModalNoButton"
        onkeypress=""
        variant="secondary"
        >
        {{ 'general.cancel' | translate }}
      </ix-button>
      <ix-button
        (click)="modal.close(passportNameInput.value)"
        [disabled]="passportNameInput.value && passportNameInput.value.trim() === ''"
        class="dismiss-modal"
        id="batteryPassChangePassportNameYesButton"
        onkeypress=""
        variant="primary">{{ 'general.save' | translate }}
      </ix-button>
    </ix-modal-footer>
  </div>
</ng-template>

<ng-template #provideAssetModal let-modal>
  <div>
    <ix-modal-header id="batteryPassWorkflowProvideAssetModalHeader">
      {{
      'battery_pass.attribute_selection.provide_asset_modal_header'
      | translate
      }}
    </ix-modal-header>
    <ix-modal-content id="batteryPassWorkflowProvideAssetModalContent">
      <form [formGroup]="cxAssetForm" class="needs-validation">
        <ix-select
          [i18nPlaceholder]="'battery_pass.attribute_selection.fields.cx_model_label'
                | translate"
          [i18nSelectListHeader]="'general.select_list_header' | translate"
          [label]="'battery_pass.attribute_selection.fields.cx_model_label'
                | translate"
          [value]="'CX_BP'"
          class="w-100"
          formControlName="schema"
          id="bpwProvideAssetModalProvisionSchema">
          <ix-select-item
            [label]="'battery_pass.edit.schemas.cx_battery_6' | translate"
            value="CX_BP"
          ></ix-select-item>
        </ix-select>
        @if (
          cxAssetForm.controls['schema'].invalid &&
          cxAssetForm.controls['schema'].dirty) {
          <div
            class="error-msg">
            {{ 'battery_pass.attribute_selection.fields.cx_model_invalid_msg'| translate }}
          </div>
        }
        <ix-input
          [label]="'battery_pass.attribute_selection.fields.asset_id_label' | translate"
          [ngClass]="{'ix-invalid': cxAssetForm.controls['assetId'].invalid}"
          [placeholder]="'battery_pass.attribute_selection.fields.asset_id_label' | translate"
          class="w-100"
          formControlName="assetId"
        id="bpwProvideAssetModalAssetId"></ix-input>
        @if (
          cxAssetForm.controls['assetId'].invalid &&
          cxAssetForm.controls['assetId'].dirty) {
          <div
            class="error-msg">
            {{ 'battery_pass.attribute_selection.fields.asset_id_invalid_msg' | translate }}
          </div>
        }
      </form>
    </ix-modal-content>
    <ix-modal-footer class="mt-2">
      <ix-button
        (click)="modal.dismiss()"
        class="close-modal"
        id="batteryPassWorkflowProvideAssetModalNoButton"
        onkeypress=""
        variant="secondary">
        {{ 'general.cancel' | translate }}
      </ix-button>
      <ix-button
        (click)="onSaveImport(); modal.close(true)"
        [disabled]="cxAssetForm.invalid"
        class="dismiss-modal"
        id="batteryPassWorkflowProvideAssetModalYesButton"
        onkeypress=""
        variant="primary"
        >{{ 'battery_pass.attribute_selection.provide_asset_save_button_text' | translate }}
      </ix-button>
    </ix-modal-footer>
  </div>
</ng-template>
